export default "__VITE_ASSET__BzAldB$M__"